module.exports = __webpack_public_path__ + "static/media/battery-empty.f03543ee.svg";